import { Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { convertTimeFormat, formatDate } from '../lib/utils';
import { useAppSelector } from '../redux/hooks';
import { handleGetUrlGuide } from '../utils/helpers';
import TutorialsVideo from './TutorialsVideo';

function HeaderBooking({ listBooking, title, dataCustomerBooking, isListTicket, isContract }: any) {
  const { t } = useTranslation();
  const listTutorials = useAppSelector((state) => state?.tutorials?.listTutorials);
  return (
    <>
      {isContract && (
        <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography className="fw-600 fs-18">{t(title)}</Typography>
          <div style={{ marginRight: '40px' }}>
            <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 8)} />
          </div>
        </Row>
      )}
      <Row gutter={12} className="mt-2">
        <div>
          <Typography className="history-info schedule">
            Tuyến:
            <span className="history-detail">
              {` ${
                listBooking?.schedule?.stops?.length > 0
                  ? listBooking?.schedule?.stops?.map((item: any) => item?.name)?.join(' -> ')
                  : ''
              } `}
            </span>
          </Typography>
          <Row gutter={20} className="mt-1">
            <Col>
              <Typography className="history-info" style={{ color: '#4F5662' }}>
                Thời gian đi:
                <span className="history-detail"> {convertTimeFormat(listBooking?.schedule?.depart_time)}</span>
              </Typography>
            </Col>
            <Col>
              <Typography className="history-info" style={{ color: '#4F5662' }}>
                Thời gian đến:
                <span className="history-detail">{` ${convertTimeFormat(listBooking?.schedule?.arrive_time)} - ${
                  listBooking?.schedule?.arrive_date
                }`}</span>
              </Typography>
            </Col>
          </Row>
        </div>
      </Row>
    </>
  );
}

export default HeaderBooking;
